import React, { useState, useEffect } from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { FilterTransport } from 'Components/widgets/criteria/criteria-transport/filter-transport/FilterTransport';
import { t } from 'Src/i18n';
import type { CriteriaForSearch } from 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
import 'Components/widgets/booking-breadcrumb/EditCriteria.utils';
import { getBookingCriteriaDepartureCities } from 'Utils/booking-engine-pages/BookingPagesUtils';
import { makeWidgetProps } from 'Src/types/widget-helpers';
type CriteriaTransportsSelectorContentPropsType = {
  newCriteria: CriteriaForSearch;
  setNewCriteria: (arg0: CriteriaForSearch) => void;
};
export const CriteriaTransportsSelectorContent = ({
  newCriteria,
  setNewCriteria,
}: CriteriaTransportsSelectorContentPropsType) => {
  const appContext = useAppContext();
  const noDepartureCitiesOptions = [
    {
      label: t('booking.priceCalendar.priceStatus.noFlight'),
      value: '',
    },
  ];
  const [departureCitiesByProductId, setDepartureCitiesByProductId] = useState([]);
  useEffect(() => {
    if (departureCitiesByProductId.length === 0) {
      getBookingCriteriaDepartureCities(newCriteria.search.value, appContext).then(
        ({ bookingCriteria: { departureCities } }) => {
          const formattedDepartureCities = departureCities.map(({ name, value }) => ({
            label: name,
            value,
          }));
          setDepartureCitiesByProductId(formattedDepartureCities);
        },
      );
    }
  }, []);
  return (
    <div className="text-black">
      <FilterTransport
        {...makeWidgetProps<React.ComponentProps<typeof FilterTransport>>({
          changeDepartureCity: (newDepartureCityId: string) => {
            const newDepartureCity = departureCitiesByProductId?.find(
              ({ value }) => value === newDepartureCityId,
            ) || {
              label: 'no transport',
              value: 'no',
            };
            !!newDepartureCity &&
              setNewCriteria({ ...newCriteria, departureCity: newDepartureCity });
          },
          className: 'h-full',
          dataTestId: 'TransportCriteria-input',
          departureCity: newCriteria?.departureCity?.value || 'NO',
          isDisabled: !departureCitiesByProductId.length,
          labelDepartingFrom: t('faceting.transport.departingFrom'),
          optionsDepartureCities:
            departureCitiesByProductId.length > 0
              ? departureCitiesByProductId
              : noDepartureCitiesOptions,
          placeholderFrom: t('faceting.transport.titleFrom'),
          selectPlaceholder: t('faceting.transport.selectPlaceholder'),
          validateDepartureCity: (noDepartureCityId) => {
            const noDepartureCity = {
              value: noDepartureCityId || 'NO',
              label: '',
            };
            setNewCriteria({ ...newCriteria, departureCity: noDepartureCity });
          },
          shouldShowNoTransportButtonMobile: false,
          withNoTransport: true,
        })}
      />
    </div>
  );
};
